<template>
    <v-row align-items="center">
        <v-col xs="9">
            <v-text v-show="warningIsActive">
                При закрытии тарифа, остаток сгорает. В целях безопасности закрытие тарифа невозможно, пока средств хватает на покупку продуктов. Если необходимо закрытие тарифа, пожалуйста, обратитесь в техподдержку
            </v-text>
        </v-col>
        <v-col v-text-align.right>
            <v-text v-if="errorMessage" error v-margin.right="3">
                {{ errorMessage }}
            </v-text>

            <v-modal :active="isShowConfirm" @close="isShowConfirm = false">
                <div v-padding="2">
                    <div v-margin.bottom="1">
                        <v-text type="title" v-margin.bottom="2">
                            Вы точно хотите закрыть тарифный план? Оставшаяся сумма будет зачислена на баланс вашего кабинета.
                        </v-text>
                    </div>

                    <div v-text-align.right v-margin.top="2">
                        <v-button v-margin.right="2" flat @click="isShowConfirm = false">
                            Отменить
                        </v-button>

                        <v-button primary @click="handleClose">
                            Закрыть тариф
                        </v-button>
                    </div>
                </div>
            </v-modal>

            <v-spinner :active="isClosing">
                <v-button @mouseleave.native="mouseleave" @mouseover.native="mouseover" primary @click="isShowConfirm = true" :disabled="btnIsDisabled">
                    закрыть тариф
                </v-button>
            </v-spinner>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        name: 'close-tariff',
        props: {
            tariff: String,
            onClose: Function,
            btnIsDisabled: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                isClosing: false,
                isShowConfirm: false,
                errorMessage: '',
                warningIsActive: false
            }
        },
        methods: {
            handleClose() {
                if (this.isClosing) {
                    return;
                }

                this.isShowConfirm = false;
                this.isClosing = true;
                this.errorMessage = '';

                this.onClose()
                    .then(() => {
                        this.isClosing = false;
                    })
                    .catch((res) => {
                        this.isClosing = false;
                        this.errorMessage = res.message;
                    })
            },
            mouseover: function(){
                if (this.btnIsDisabled) this.warningIsActive = true;
                
            },    
            mouseleave: function(){
                if (this.btnIsDisabled) this.warningIsActive = false;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// CloseTariff.vue?1158326c